<template>
  <div class="Variousroles-li">
    <div class="Variousroles-name"
         @mouseover="showBtnProxy=(['ROLE_ATT','ROLE_SC'].includes(roleKey)&&!taskDone) || ('ROLE_ATT' === roleKey && taskDoneBtnEnabled) || ('ROLE_SC' === roleKey && taskDoneBtnEnabled)"
         @mouseleave="showBtnProxy=false">
      {{ roleComment }}
      <span class="btbt" v-show="!showBtnProxy" :style="{color:taskDone?'#65C58C':'#EBA967'}">{{
          taskDone ? '已完成' : '处置中'
        }}</span>
      <div v-show="showBtnProxy" class="btn-proxy" @click="showTaskTodoProxyDialog=true">代理处置</div>
    </div>
    <div class="Variousroles-line">
      <div class="Variousroles-line-date">{{ `${taskDoneRate}%` }}</div>
      <div class="Variousroles-line-box">
        <div class="line" :style="`width: ${taskDoneRate}%`"></div>
      </div>
    </div>
    <div class="Variousroles-text">
      <div :class="item.style" v-for="item in tasks" :key="item.ordinal">{{ item.label }}</div>
    </div>
    <task-todo-proxy-dialog v-if="showTaskTodoProxyDialog"
                            :visible.sync="showTaskTodoProxyDialog"
                            :event-id="eventId"
                            :event-type="eventType"
                            :role-key="roleKey"
                            :role-comment="roleComment"
                            :done="done"
                            :task-done-btn-enabled="taskDoneBtnEnabled"
                            :data-rows="dataRows"
    />
  </div>
</template>

<script>

import TaskTodoProxyDialog from "@/views/Eventhandling/components/TaskTodoProxyDialog.vue";

export default {
  components: {TaskTodoProxyDialog},
  props: {
    roleKey: {
      type: String,
      required: true
    },
    roleComment: {
      type: String,
      required: true
    },
    eventId: {
      type: String,
      required: true
    },
    eventType: {
      type: String,
      required: true
    },
    done: {
      type: Boolean,
      required: true
    },
    taskDoneBtnEnabledAtt: {
      default: false,
      type: Boolean,
      required: false
    },
    taskDoneBtnEnabledSc: {
      default: false,
      type: Boolean,
      required: false
    },
    dataRows: {
      type: Array,
      required: true
    }
  },
  data() {
    // console.log(['TaskListCard.vue data', this.roleKey, this.roleComment, this.dataRows])
    return {
      tasks: this.getTasks(this.dataRows),
      showBtnProxy: false,
      showTaskTodoProxyDialog: false, // 代理完成待办事项弹窗控制
      taskDoneBtnEnabled: ('ROLE_ATT' === this.roleKey && this.taskDoneBtnEnabledAtt)
        || ('ROLE_SC' === this.roleKey && this.taskDoneBtnEnabledSc)
    }
  },
  watch: {
    dataRows: {
      deep: true,// true 深度监听
      handler(val, oldVal) {
        // console.log(['TaskListCard.vue watch', this.roleKey, this.roleComment, this.dataRows])
        this.tasks = this.getTasks(this.dataRows)
      }
    },
    taskDoneBtnEnabledAtt: function (val) {
      if ('ROLE_ATT' === this.roleKey) {
        this.taskDoneBtnEnabled = val
      }
    },
    taskDoneBtnEnabledSc: function (val) {
      if ('ROLE_SC' === this.roleKey) {
        this.taskDoneBtnEnabled = val
      }
    }
  },
  computed: {
    taskDone() {
      return this.tasks.every(ele => ele.done)
    },
    taskDoneRate() {
      const total = this.tasks.length
      if (total === 0) {
        return 100
      }
      const doneCount = this.tasks.filter(task => task.done).length
      return total === 0 ? 100 : Math.round(doneCount / total * 100)
    },
  },
  methods: {
    getTasks(dataRows) {
      const rows = dataRows.filter(row => row.priority === 'ETP2')
        .concat(dataRows.filter(row => row.priority !== 'ETP2'))
      rows.forEach(row => {
        row.style = row.done ? (row.value === 'ETV2' ? 'Variousroles-p active' : 'Variousroles-p') : 'Variousroles-p active2'
      })
      return rows
    },
    // 1、进入元素
    mouseover() {
      console.log('mouseover')
    },
    // 5、离开元素
    mouseleave() {
      console.log('mouseleave')
    }
  }
};
</script>
<style lang="less">
    .el-checkbox, .el-checkbox__input{
      white-space:normal;
    }
</style>
<style lang="less" scoped>

.Variousroles-li:nth-child(2n) {
  margin-left: 16px;
}

.Variousroles-li {
  background: #393F52;
  border-radius: 8px;
  width: calc(50% - 8px);
  padding: 16px 0;
  margin-bottom: 16px;
}

.Variousroles-name {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.87);
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;

  span {
    color: #EBA967;
    font-size: 12px;
  }
}

.Variousroles-line {
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #262D40;

  .Variousroles-line-date {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.87);
  }

  .Variousroles-line-box {
    background: #0F1526;
    border-radius: 8px;
    height: 8px;
    position: relative;
    overflow: hidden;
    padding: 1px;
    margin-top: 8px;

    .line {
      background: linear-gradient(270deg, #83D7A5 0%, #65C58C 100%);
      border-radius: 8px;
      height: 100%;
    }
  }
}
  .inspection-li{
    position: relative;
    color: #65C58C;
    font-size: 12px;
    margin-bottom: 6px;
    line-height: 18px;
    padding-left: 12px;
  }
  .inspection-li:before {
    content: '';
    display: block;
    position: absolute;
    width: 4px;
    height: 4px;
    background: #65C58C;
    border-radius: 50%;
    left: 0;
    top: 7px;
  }
  .inspection-li.active {
    color: #6CD8FF;
  }

  .inspection-li.active:before {
    background: #6CD8FF;
  }

  .inspection-li.active2 {
    color: #FFFFFF;
  }

  .inspection-li.active2:before {
    background: #fff;
  }

  .inspection-li.active3 {
    color: rgba(255, 255, 255, 0.6);
  }

  .inspection-li.active3:before {
    background: rgba(255, 255, 255, 0.6);
  }

  .inspection-li.active {
      color: #6CD8FF;
  }
  .inspection-li.active3 {
      color: #5CBE85;
  }
  .inspection-li.active2 {
      color: #606266;
  }
.Variousroles-text {
  padding: 12px;
  height: 127px;
  overflow: auto;
  text-align: left;

  .Variousroles-p.active {
    color: #6CD8FF;
  }

  .Variousroles-p.active:before {
    background: #6CD8FF;
  }

  .Variousroles-p.active2 {
    color: #FFFFFF;
  }

  .Variousroles-p.active2:before {
    background: #fff;
  }

  .Variousroles-p.active3 {
    color: rgba(255, 255, 255, 0.6);
  }

  .Variousroles-p.active3:before {
    background: rgba(255, 255, 255, 0.6);
  }

  .Variousroles-p:before {
    content: '';
    display: block;
    position: absolute;
    width: 4px;
    height: 4px;
    background: #65C58C;
    border-radius: 50%;
    left: 0;
    top: 7px;
  }

  .Variousroles-p {
    position: relative;
    color: #65C58C;
    font-size: 12px;
    margin-bottom: 6px;
    line-height: 18px;
    padding-left: 12px;
  }
}
.btbt{
  height: 25px;
  line-height: 25px;
  padding: 0 10px;
}
.btn-proxy {
  cursor: pointer;
  background: #1F60C1;
  border-radius: 8px;
  font-size: 13px;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.87);
  height: 25px;
  line-height: 25px;
  padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Eventhandling/components/TaskListCard.vue